import React from 'react'
import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import { useEmployeesState } from '../../stores/EmployeesProvider'
import InformationPopover from '../InformationPopover/InformationPopover'
import { useTranslation } from 'react-i18next'

const StyledCatalogViewSwitch = styled.div`
  margin-bottom: 25px;
  font-weight: bold;
  .custom-control-label {
    font-size: 20px;
  }
  .custom-control-label::before {
    top: 0.5rem;
  }
  .custom-control-label::after {
    top: calc(0.5rem + 2px);
  }
`
const MissingArticleConfigurationsFilter = () => {
  const {
    setMissingArticleConfigurationsFilter,
    missingArticleConfigurationsFilter,
  } = useEmployeesState()

  const { t } = useTranslation()
  const handleChange = (e) => {
    setMissingArticleConfigurationsFilter((prev) => !prev)
  }
  return (
    <div className={'d-flex'}>
      <StyledCatalogViewSwitch>
        <Form.Check
          type='switch'
          label={t('sizeDetection:employeeMissingSizes')}
          onChange={handleChange}
          id='catalog-view-switch'
          checked={missingArticleConfigurationsFilter || false}
        />
      </StyledCatalogViewSwitch>
      <InformationPopover
        header={t('sizeDetection:employeeMissingSizes')}
        content={t('sizeDetection:employeeFilterMsg')}
      />
    </div>
  )
}

export default MissingArticleConfigurationsFilter
